import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import { displayResourceStyles } from '../../../css/style';

const styles = displayResourceStyles();

export const ViewMoreRow = ({
  onClickViewMore,
  rowData,
  resourceName,
  isFiltersSameAsLastUsedFilters,
  submitFilters,
}) => {
  const choiceProps = { onClickViewMore, submitFilters, rowData };
  const buttonOnlyProps = { onClickViewMore, rowData };
  if (resourceName === 'orders' && !isFiltersSameAsLastUsedFilters) {
    return (
      <ViewMoreChoiceRow
        {...choiceProps}
      />
    );
  }
  return (
    <ViewMoreButton
      {...buttonOnlyProps}
    />
  );
};

const ViewMoreChoiceRow = ({ onClickViewMore, submitFilters, rowData }) => (
  <div style={styles.viewMoreChoiceRow}>
    <Typography style={styles.viewMoreChoiceText}>Filters changed.</Typography>
    <Button
      onClick={submitFilters}
      style={styles.viewMoreButton}
    >
      Apply New Filter
    </Button>
    <Typography style={styles.viewMoreChoiceText}>Or</Typography>
    <ViewMoreButton
      onClickViewMore={onClickViewMore}
      rowData={rowData}
    />
    <Typography style={styles.viewMoreChoiceText}>of old filter?</Typography>
  </div>
);

const ViewMoreButton = ({ onClickViewMore, rowData }) => (
  <Button
    onClick={() => onClickViewMore()}
    style={styles.viewMoreButton}
  >
    {rowData.value}
    <KeyboardArrowDown style={styles.keyDownIcon} />
  </Button>
);
